import { CopyableId } from "@coval/ui"

import type { TestCaseOption } from "@/types_api/backend/transport/list_test_cases_transport_response"
import type { CsvColumnDef } from "@/utils/csv/tableCsvColumns"

export const testCaseLibraryColumns: CsvColumnDef<TestCaseOption>[] = [
  {
    id: "description",
    header: "Test Case",
    width: 280,
    variant: "name",
    csvValue: (row) => row.description,
    cell: (row) => (
      <span className="truncate" title={row.description || undefined}>
        {row.description || (
          <span className="text-coval-text-muted">No description</span>
        )}
      </span>
    ),
  },
  {
    id: "test_set_name",
    header: "Test Set",
    width: 180,
    csvValue: (row) => row.test_set_name,
    cell: (row) => <span className="truncate">{row.test_set_name}</span>,
  },
  {
    id: "id",
    header: "ID",
    width: 104,
    variant: "id",
    pinned: "right",
    csvValue: (row) => row.id,
    cell: (row) => <CopyableId id={row.id} />,
  },
]
